import { render } from "./ShowMobile.vue?vue&type=template&id=4c430b38&lang=pug"
import script from "./ShowMobile.vue?vue&type=script&lang=ts"
export * from "./ShowMobile.vue?vue&type=script&lang=ts"
script.render = render

export default script